import Page0 from "../pages/Page0";
import Page1 from "../pages/Page1";
import Page2 from "../pages/page2/Page2";
import Page3 from "../pages/Page3";
import Page4 from "../pages/Page4";
import Page5 from "../pages/Page5";
import Page6 from "../pages/Page6";
import Page7 from "../pages/Page7";
import Page8 from "../pages/Page8";
import Page9 from "../pages/Page9";
import Page10 from "../pages/Page10";
import Page11 from "../pages/Page11";
import Page12 from "../pages/Page12";
import Page13 from "../pages/Page13";
import Page14 from "../pages/Page14";
import Page15 from "../pages/Page15";
import Page16 from "../pages/page16/Page16";
import Page17 from "../pages/page17/Page17";

export const routes = [
  { path: "", element: <Page0 />, hideNavigation: false },
  { path: "/1", element: <Page1 />, hideNavigation: false },
  { path: "/2", element: <Page2 />, hideNavigation: false },
  { path: "/3", element: <Page3 />, hideNavigation: false },
  { path: "/4", element: <Page4 />, hideNavigation: false },
  { path: "/5", element: <Page5 />, hideNavigation: false },
  { path: "/6", element: <Page6 />, hideNavigation: false },
  { path: "/7", element: <Page7 />, hideNavigation: false },
  { path: "/8", element: <Page8 />, hideNavigation: false },
  { path: "/9", element: <Page9 />, hideNavigation: false },
  { path: "/10", element: <Page10 />, hideNavigation: false },
  { path: "/11", element: <Page11 />, hideNavigation: false },
  { path: "/12", element: <Page12 />, hideNavigation: false },
  { path: "/13", element: <Page13 />, hideNavigation: false },
  { path: "/14", element: <Page14 />, hideNavigation: false },
  { path: "/15", element: <Page15 />, hideNavigation: false },
  { path: "/16", element: <Page16 />, hideNavigation: false },
  { path: "/17", element: <Page17 />, hideNavigation: false },
];
